import React from 'react';
import { ProductItem } from './ProductItem';
import { TrackSearch } from '../../SiteHeaderTracking';
import { SearchSource } from '../Enum/SearchSource';
import { useAppState } from '../../AppStateContext';
import { KlevuResultEvent } from '@klevu/core';

interface ProductsSectionProps {
  clickManager: KlevuResultEvent['searchClickEvent'];
}

export const ProductSection = ({ clickManager }: ProductsSectionProps) => {
  const { products, searchTerm } = useAppState();
  const translations = window._THULEDATA._siteHeader.Translations;

  if (!searchTerm.length || !products?.length) return null;

  return (
    <div className="products-section pb-8">
      <p className="paragraph--s section-sub-header">{translations?.SearchProducts}</p>
      <div className="products d-flex">
        {products.map((product, i) => (
          <ProductItem
            key={i}
            product={product}
            onClick={() => {
              TrackSearch(searchTerm, SearchSource.SuggestedPDP);
              clickManager?.({ productId: product.id });
            }}
          />
        ))}
      </div>
    </div>
  );
};
